import moment from "moment";
import { Box, IconButton, SvgIcon, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  DAYS_UP_TO_TODAY,
  LAST_30_DAYS_DATE_FORMAT,
  LAST_7_DAY_DATE_FORMAT,
  LAST_MONTH_END_DATE_FORMAT,
  LAST_MONTH_START_DATE_FORMAT,
  MONTH_TO_DATE_FORMAT,
  TODAY_DATE_FORMAT,
  YEAR_TO_DATE_FORMAT,
} from "../Constants/Constants";
import Routes from "./Routes";

const styles = {
  parent: {
    fontSize: "22px",
    fontWeight: 400,
    lineHeight: "25.78px",
    color: "#505050",
    p: "0px 12px",
  },
  add: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "18.75px",
    color: "#7F7F7F",
    textAlign: "left",
  },
  addIcon: {
    p: 0,
    // color: "#828282",
  },
  initialMainBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "270px",
    p: "10px",
  },
  headingBox: {
    textAlign: "left",
    width: "250px",
  },
  initialSubBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "270px",
    gap: "5px",
    mt: "5px",
  },
};

export const balanceConvertion = (balance) => {
  let newBalance = 0;
  /* istanbul ignore if */
  if (balance !== null) {
    /* istanbul ignore if */
    if (balance < 1073741824) {
      newBalance =
        balance === 0
          ? `${0} MB`
          : `${(balance / (1024 * 1024)).toFixed(2)} ` + "MB";
    }
    /* istanbul ignore if */
    if (balance >= 1073741824 && balance < 1099511627776) {
      newBalance = `${(balance / (1024 * 1024 * 1024)).toFixed(2)} ` + "GB";
    }
    /* istanbul ignore if */
    if (balance >= 1099511627776) {
      newBalance =
        `${(balance / (1024 * 1024 * 1024 * 1024)).toFixed(2)} ` + "TB";
    }
  }
  return newBalance.toString();
};
/* istanbul ignore next */
export const checkDecimalPoint = (value) =>
  Number.isInteger(value) ? value : Number(value.toFixed(2));
/* istanbul ignore next */
export const capFirstLetterCapBeforeSpace = (s) =>
  s?.replace(/([A-Z])/g, " $1")?.replace(/^./, function (str) {
    return str.toUpperCase();
  });
/* istanbul ignore next */
export const standardtDateRange = (range) => {
  // const today = moment();
  let value;
  switch (range) {
    case "LAST_7_DAYS":
      value = {
        date: [LAST_7_DAY_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Last 7 Days",
      };
      break;
    case "MONTH_TO_DATE":
      value = {
        date: [MONTH_TO_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Month to Date",
      };
      break;
    case "LAST_30_DAYS":
      value = {
        date: [LAST_30_DAYS_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Last 30 Days",
      };
      break;
    case "LAST_MONTH":
      value = {
        date: [LAST_MONTH_START_DATE_FORMAT, LAST_MONTH_END_DATE_FORMAT],
        type: "Last Month",
      };
      break;
    case "YEAR_TO_DATE":
      value = {
        date: [YEAR_TO_DATE_FORMAT, TODAY_DATE_FORMAT],
        type: "Year to Date",
      };
      break;
    default:
      break;
  }
  return value;
};
/* istanbul ignore next */
export const selectCustomDateRange = (e, name, prevData) => {
  let value;
  const startDate = e[0];
  const endDate = e[1];
  const today = moment();
  /* istanbul ignore if */
  if (today <= startDate) {
    value = {
      date: [today, null],
      type: "Custom Date",
    };
  } else if (today <= endDate) {
    value = {
      date: [startDate, today],
      type: "Custom Date",
    };
  } else if (endDate !== null && endDate < startDate) {
    value = { date: [endDate, null], type: "Custom Date" };
  } else {
    value = { date: [startDate, endDate], type: "Custom Date" };
  }
  return value;
};
/* istanbul ignore next */
export const daysUpToDate = (e, name, prevData) => {
  const isValidNumber = e.target.value.replace(/[^0-9]/g, "");
  if (isValidNumber !== " ")
    return {
      date: [
        isValidNumber === "1" || isValidNumber === "" || isValidNumber === "0"
          ? TODAY_DATE_FORMAT
          : moment().subtract(isValidNumber - 1, "days"),
        TODAY_DATE_FORMAT,
      ],
      type: `${isValidNumber} ${DAYS_UP_TO_TODAY}`,
      value: isValidNumber === "0" || isValidNumber === "" ? "" : isValidNumber,
    };
  return prevData;
};

/* istanbul ignore next */
export const capitalizeFLetter = (str) => {
  if (!str) return "";
  const strings = str.split(" ");
  return strings
    .map((string) =>
      string ? string.charAt(0).toUpperCase() + string.slice(1) : "",
    )
    .join(" ");
};
/* istanbul ignore next */
export const changeGroupName = (str) =>
  capitalizeFLetter(str?.toLowerCase().split("_").join(" "));
/* istanbul ignore next */
export const dateFormatMMDDYYYY = (date) => moment(date).format("MM-DD-YYYY");

export const addCustomEvent = (player) => {
  /* istanbul ignore if */
  if (!player?.eventList?.length) return player;
  const eventLabels = ["Custom Event", "Dolby Millicast Events All"];
  player.eventList = player.eventList.filter((eventObj) => {
    /* istanbul ignore if */
    if (eventLabels.includes(eventObj.label)) {
      eventObj.group =
        eventObj.label === "Custom Event" ? "Custom Data" : "Dolby Millicast";
      player.metaDataList.push(eventObj);
      return false;
    }
    return true;
  });
  return player;
};

export const updateFilterName = (filter) => ({
  ...filter,
  adFrameWork: filter?.adFrameWork?.map((item) =>
    item === "Yospace" ? "YoSpace" : item,
  ),
});
export const clearSessionDetails = () => {
  const sessionNames = [
    "sortDatapipe",
    "sortCollector",
    "sortConnector",
    "companyFilter",
    "userFilter",
    "dataDictionaryFilter",
    "customDataFilter",
  ];
  sessionNames.forEach((key) => sessionStorage.removeItem(key));
};

export function SvgCustomIcon({ value, style, svgStyle }) {
  return (
    <SvgIcon style={svgStyle}>
      <path d={value} style={style} />
    </SvgIcon>
  );
}
export function changeExtensionToSvg(url) {
  return url.replace(".png", ".svg");
}
export function datapointGroupCount(groupCounts, item) {
  if (!groupCounts[item.mainGroup]) {
    groupCounts[item.mainGroup] = {};
  }

  // Handle subgroups for Metadata
  if (item.group === "Metadata") {
    if (!groupCounts[item.mainGroup][item.group]) {
      groupCounts[item.mainGroup][item.group] = {};
    }
    if (!groupCounts[item.mainGroup][item.group][item.subGroup]) {
      groupCounts[item.mainGroup][item.group][item.subGroup] = 0;
    }
    // Increment count if item is selected or required
    if (item.selected || item.required) {
      groupCounts[item.mainGroup][item.group][item.subGroup]++;
    }
  } else {
    if (!groupCounts[item.mainGroup][item.group]) {
      groupCounts[item.mainGroup][item.group] = 0;
    }
    // Increment count if item is selected or required
    if (item.selected || item.required) {
      groupCounts[item.mainGroup][item.group]++;
    }
  }
  return groupCounts;
}
export function resetDatapointGroupCount(groupCounts, item) {
  if (!groupCounts[item.mainGroup]) {
    groupCounts[item.mainGroup] = {};
  }

  // Only reset counts if item.required is false
  if (!item.required) {
    // Handle subgroups for Metadata
    if (item.group === "Metadata") {
      if (!groupCounts[item.mainGroup][item.group]) {
        groupCounts[item.mainGroup][item.group] = {};
      }
      groupCounts[item.mainGroup][item.group][item.subGroup] = 0;
    } else {
      groupCounts[item.mainGroup][item.group] = 0;
    }
  }
  return groupCounts;
}

export const getCollectorDetailsKeyAndName = (details, key) =>
  details?.[key]
    ? {
        key: details[key].key,
        name: details[key].name,
        status: details[key].status,
        jiraIntegrationStatus: details[key].jiraIntegrationStatus,
        type: details[key].type,
        id: details[key].id,
        supportSampling: details[key].supportSampling,
        appSessionTimeOut: details[key].supportAppSessionTimeOut,
        cmcdStatus: details[key].supportCmcd,
        collectorImage: details[key].collectorImage,
      }
    : null;

export function transformDataWithIDAndName(data) {
  return data.map((item) => ({
    id: item?.datapipe,
    name: item?.datapipeName,
  }));
}

export const createHeaderLabel = (title, isExpanded) => (
  <Box
    sx={{
      ...styles.headingBox,
      ...(isExpanded ? { width: "467px" } : {}),
    }}
  >
    <Typography
      sx={{
        ...styles.parent,
        ...(isExpanded ? { p: "0px" } : {}),
      }}
    >
      {title}
    </Typography>
  </Box>
);

export const createConfigLabel = (handleAddFn, labelText, isExpanded) => (
  <Box
    sx={{
      ...styles.initialMainBox,
      ...(isExpanded ? { width: "467px", p: "10px 0px" } : {}),
    }}
  >
    <Box sx={styles.initialSubBox}>
      <IconButton aria-label="close" onClick={handleAddFn} sx={styles.addIcon}>
        <AddCircleOutlineIcon sx={{ width: 40, height: 40 }} />
      </IconButton>{" "}
      <Typography sx={styles.add}>{labelText}</Typography>
    </Box>
  </Box>
);

export const handleBreadcrumbRoute = (
  titleName,
  pathnames,
  titleNameTwo,
  selectedName,
  selectedSubName,
  selectedCoSubName,
) => {
  const createRoute = (name, route, options = {}) => ({
    name,
    route,
    ...options,
  });

  const routingRules = {
    "data-pipe-list": [
      createRoute(titleName, Routes.datapipeList, { disabled: true }),
      createRoute("Data Pipe List", Routes.datapipeList, { disabled: true }),
    ],
    "data-pipe-details": [
      createRoute(titleName, Routes.datapipeList, { disabled: false }),
      createRoute("Data Pipe Details", Routes.datapipeList, { disabled: true }),
    ],
    "view-pipe": [
      createRoute(titleName, Routes.datapipeList),
      createRoute(titleNameTwo, Routes.datapipeList),
      createRoute("View Pipe", Routes.viewPipe, { disabled: true }),
    ],
    "edit-pipe": [
      createRoute(titleName, Routes.datapipeList),
      createRoute(titleNameTwo, Routes.datapipeList),
      createRoute("Edit Pipe", Routes.editPipe, { disabled: true }),
    ],
    "collector-list": [
      createRoute(titleName, Routes.collectorList, { disabled: true }),
      createRoute("Collector List", Routes.collectorList, { disabled: true }),
    ],
    "collector-configuration": [
      createRoute(titleName, Routes.collectorList),
      createRoute("Collector Configuration", Routes.collectorConfiguration, {
        disabled: true,
      }),
    ],
    "connector-list": [
      createRoute(titleName, Routes.connectorList, { disabled: true }),
      createRoute("Connector List", Routes.connectorList),
    ],
    "connector-configuration": [
      createRoute(titleName, Routes.connectorList),
      createRoute("Connector Configuration", Routes.connectorConfiguration, {
        disabled: true,
      }),
    ],
    users: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Users", Routes.dashboard, { selected: true }),
    ],
    projects: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Projects", Routes.dashboard, { selected: true }),
    ],
    "custom-data": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Custom Data", Routes.dashboard, { selected: true }),
    ],
    "billing-usage": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Billing & Usage", Routes.dashboard, { selected: true }),
    ],
    companies: [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Companies", Routes.dashboard, { selected: true }),
    ],
    "rate-cards": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
    ],
    "data-point-management": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Data Point Management", Routes.dashboard, {
        selected: true,
      }),
    ],
    "collector-management": [
      createRoute(titleName, Routes.dashboard, { disabled: true }),
      createRoute("Collector Management", Routes.dashboard, { selected: true }),
    ],
  };

  const breadcrumbSegments =
    routingRules[pathnames.join("/")]?.map((rule) => ({
      ...rule,
      disabled: rule.disabled ?? false,
    })) || [];

  [selectedName, selectedSubName, selectedCoSubName].forEach((name) => {
    if (name) breadcrumbSegments.push({ name });
  });
  return breadcrumbSegments;
};

export const handleChunkError = (event) => {
  if (
    event?.message?.includes("ChunkLoadError") ||
    event?.reason?.message?.includes("ChunkLoadError")
  ) {
    window.location.reload();
  }
};
